import { Slide, ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import "./helocPortalToast.css"

function HelocPortalToastContent({ message, variant }) {
  const iconSrc =
    variant === "error" ? "/icons/times-circle.svg" : "/icons/check-circle-green.svg"

  return (
    <div className="heloc-portal-toast-content">
      <img src={iconSrc} alt="" aria-hidden="true" className="heloc-portal-toast-icon" />
      <span className="heloc-portal-toast-message">{message}</span>
    </div>
  )
}

export function HelocPortalToastHost() {
  return (
    <ToastContainer
      position="bottom-center"
      autoClose={5000}
      draggable
      closeOnClick
      pauseOnHover
      hideProgressBar
      theme="dark"
      transition={Slide}
      icon={false}
      toastClassName="heloc-portal-toast"
      bodyClassName="heloc-portal-toast-body"
    />
  )
}

// `options` are react-toastify options for this one toast (position, toastId, ...).
export function showHelocPortalSuccessToast(message, options) {
  if (!message) return
  toast.success(<HelocPortalToastContent message={message} variant="success" />, options)
}

export function showHelocPortalErrorToast(message, options) {
  if (!message) return
  toast.error(<HelocPortalToastContent message={message} variant="error" />, options)
}
